import { useFetch } from "@chainless/chainless-react";
import { DataTable } from "primereact/datatable";
import { ApproveVerlof } from "../components/ApproveVerlof";
import { useState } from "react";
import { Column } from "primereact/column";
import "../index.css";
import { TextPopup } from "../components/TextPopup";

export const VerlofPage = () => {
  const { data: verlof, error, loading, fetchData } = useFetch(`/api/verlof`);
  const { data: user } = useFetch(`/api/graph/user`);
  const [expandedRows, setExpandedRows] = useState();

  return (
    <>
      {loading && <p>Verlof ophalen...</p>}
      {error && <p>Error bij ophalen verlof: {error}</p>}
      {verlof && verlof.length > 0 && (
        <>
          <div className="inhoud">
            <div className="tabel" style={{ minHeight: "55vh" }}>
              <h1>Verlof</h1>
              <div className="table">
                <DataTable
                  value={verlof}
                  stripedRows
                  showGridlines
                  paginator={true}
                  paginatorTemplate="PrevPageLink PageLinks NextPageLink CurrentPageReport"
                  rows={10}
                  rowExpansionTemplate={(rowData) => (
                    <ApproveVerlof rowData={rowData} fetch={fetchData} user={user.id}/>
                  )}
                  expandedRows={expandedRows}
                  onRowToggle={(e) => setExpandedRows(e.data)}
                  rowClassName={rowData =>
                    rowData.statusAanvraag === "GOEDGEKEURD"
                      ? "verlof-row-goedgekeurd"
                      : rowData.statusAanvraag === "AFGEWEZEN"
                        ? "verlof-row-afgekeurd"
                        : ""
                  }
                >
                  <Column expander style={{ minWidth: "3em" }} />
                  <Column
                    className="table-column"
                    field="aanvrager"
                    header="Aanvrager"
                  />
                  <Column
                    className="table-column"
                    field="omschrijving"
                    header="Omschrijving"
                    body={(rowData) => (
                      <TextPopup
                        text={rowData.omschrijving}
                        headerText={"Omschrijving"}
                      />
                    )}
                  />
                  <Column
                    className="table-column"
                    field="data"
                    header="Verlof dagen"
                    body={(rowData) =>
                      new Date(rowData.start * 1000).toLocaleDateString(
                        "nl-NL"
                      ) +
                      " t/m " +
                      new Date(rowData.eind * 1000).toLocaleDateString("nl-NL")
                    }
                  />
                  <Column
                    className="table-column"
                    field="excludedDays"
                    header="Uitgezonderde dagen"
                    body={(rowData) => (
                      <TextPopup
                        text={rowData.excludedDays
                          .map(
                            (day) =>
                              `${new Date(
                                day.excludedDay * 1000
                              ).toLocaleDateString("nl-NL")} ${
                                day.hours === "4" ? " Halve dag" : ""
                              }`
                          )
                          .join(" en ")}
                        headerText={"Uitgezonderde dagen"}
                      />
                    )}
                  />
                  <Column
                    style={{ minWidth: "3em" }}
                    field="uren"
                    header="Uren"
                  />
                  <Column
                    className="table-column"
                    field="goedgekeurdDoor"
                    header="Goedkeurder"
                  />
                  <Column
                    className="table-column"
                    field="datumGoedgekeurd"
                    header="Datum goedgekeurd"
                    body={(rowData) =>
                      rowData.datumGoedgekeurd
                        ? new Date(
                          rowData.datumGoedgekeurd * 1000
                        ).toLocaleDateString("nl-NL")
                        : null
                    }
                  />
                  <Column
                    className="table-column"
                    field="statusAanvraag"
                    header="Status"
                    body={(rowData) =>
                      rowData.statusAanvraag === "IN_BEHANDELING"
                        ? "In behandeling"
                        : rowData.statusAanvraag === "GOEDGEKEURD"
                          ? "Goedgekeurd"
                          : rowData.statusAanvraag === "AFGEKEURD"
                            ? "Afgekeurd"
                            : rowData.statusAanvraag
                    }
                  />
                </DataTable>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
